// @flow

import * as React from 'react';
import classNames from 'classnames';

type ListItemProps = {|
  number?: number,
  id?: string,
  className?: string,
  children?: React.Node,
|};

export const ListItem = ({number, id, className, children}: ListItemProps) => {
  const props = {
    id,
    className: classNames(className, {
      'ListItem--hasMultipleChildren':
        Array.isArray(children) && children.length > 1,
    }),
    style: undefined,
  };

  if (number && !isNaN(number)) {
    props.style = {
      counterReset: `listitem ${number - 1}`,
    };
  }

  return React.createElement('li', props, children);
};
